import { Helpers } from '../Helpers';
import React, { Component } from 'react';
import ReactDOM from 'react-dom';

export default class Pagination extends Component
{
    constructor(props) {
        super(props);

        this.state = {
            from: this.props.currentPage > 1 ? ((this.props.currentPage - 1) * this.props.pageSize) + 1 : 1,
            nextPage: (this.props.currentPage * this.props.pageSize) < this.props.total ? this.props.currentPage + 1 : null,
            previousPage: this.props.currentPage > 1 ? this.props.currentPage - 1 : null,
            to: this.props.currentPage * this.props.pageSize < this.props.total ? this.props.currentPage * this.props.pageSize : this.props.total,
        };
        
        this.urlParams = this.urlParams.bind(this);
    }
    
    urlParams(page)
    {
        let params = _.omit(this.props.request, 'page');
        
        return _.assign({ page: page }, params);
    }
    
    render()
    {
        const { baseUrl, request, route, router } = this.props; 
        
        return (
                <ul className="list-inline mb-0 d-flex align-items-center">
                    <li className="list-inline-item mr-4">
                        <div className="">
                            <span className="font-weight-bold">
                                {this.state.from} 
                            </span>
                            
                            {
                                this.state.to > 1 && 
                                <span className="font-weight-bold"> — {this.state.to}</span>
                            }
                            
                            <span className="text-muted"> of {numeral(this.props.total).format('0,0')}</span>
                        </div>
                    </li>
                    
                    <li className="list-inline-item">
                        <a 
                            className={this.state.previousPage ? "btn btn-flat" : "btn btn-flat disabled"} 
                            href={Helpers.url(baseUrl, this.urlParams(this.state.previousPage))}
                        >
                            <i className="fa fa-fw fa-chevron-left"></i>
                        </a>
                    </li>
                    <li className="list-inline-item">
                        <a 
                            className={this.state.nextPage ? "btn btn-flat" : "btn btn-flat disabled"} 
                            href={Helpers.url(baseUrl, this.urlParams(this.state.nextPage))}
                        >
                            <i className="fa fa-fw fa-chevron-right"></i>
                        </a>
                    </li>
                    <li className="list-inline-item">
                        <div className="dropdown">
                            <button className="btn btn-flat dropdown-toggle no-caret" type="button" data-toggle="dropdown">
                                <i className="fa fa-fw fa-cog"></i>
                            </button>
                            <div className="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
                                <a className="dropdown-item" href="#">Settings</a>
                                <div className="dropdown-divider"></div>
                                <a className="dropdown-item"
                                   data-toggle="modal"
                                   data-target="#feedbackModal"><i className="fa fa-lg fa-fw fa-bug mr-2"></i>Report a problem</a>
                                <a className="dropdown-item" href={router.url('support.home')} target="_blank"><i className="far fa-lg fa-fw fa-question-circle mr-2"></i>Help</a>
                            </div>
                        </div>
                    </li>
                </ul>
                );
    }
}



// WEBPACK FOOTER //
// ./resources/js/components/Core/Pagination.js